var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { forwardRef } from 'react';
import { cn } from 'root/src/client/v2/common/helpers/cn';
export const Textarea = forwardRef((_a, ref) => {
    var { className, error } = _a, props = __rest(_a, ["className", "error"]);
    return (<textarea ref={ref} className={cn('w-full rounded-lg border border-solid border-white/[0.06] bg-white/[0.03] px-3 py-2 text-sm text-foreground placeholder:text-muted-foreground/30 transition-colors focus:border-primary/30 focus:outline-none', error && 'border-destructive/50 focus:border-destructive/50', className)} {...props}/>);
});
Textarea.displayName = 'Textarea';
